import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import { FlowPageModel, type IFlowPageModel } from "models/flow/FlowPageModel";
import { PageModel, type IPageModel } from "models/flow/PageModel";
import React from "react";

/**
 * Interface para o modelo de Fluxo (Flow).
 * Define as páginas que compõem um fluxo de navegação.
 */
export interface IFlowModel extends IGenericBaseModel {
  name: string;
  flowpages: IFlowPageModel[];
  redirectPageWhenFinished?: IPageModel | null;
}

/**
 * Classe que representa um Fluxo de navegação.
 */
export class FlowModel implements IFlowModel {
  uuid?: string;
  key?: React.Key;
  name: string;
  flowpages: FlowPageModel[] = [];
  redirectPageWhenFinished: PageModel | null;

  constructor(data: IFlowModel) {
    this.uuid = data?.uuid;
    this.key = data?.uuid;
    this.name = data?.name ?? '';

    // Mapeia os dados da interface para instâncias da classe FlowPageModel
    if (data?.flowpages?.length > 0) {
      this.flowpages = data.flowpages.map(fp => new FlowPageModel(fp));
    }

    // Instancia a página de redirecionamento se ela existir
    this.redirectPageWhenFinished = data.redirectPageWhenFinished
      ? new PageModel(data.redirectPageWhenFinished)
      : null;
  }
}